module.exports = __webpack_public_path__ + "img/Pista_1901.a0840e98.png";